import { render, staticRenderFns } from "./user-edit.vue?vue&type=template&id=a740f08e&scoped=true&"
import script from "./user-edit.vue?vue&type=script&lang=js&"
export * from "./user-edit.vue?vue&type=script&lang=js&"
import style0 from "./user-edit.vue?vue&type=style&index=0&id=a740f08e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a740f08e",
  null
  
)

export default component.exports